import Icon from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import React from "react";
import TextInput, { type TextInputProps } from "./component";
import { maskValue } from "./lib";

export type TextInputSensitiveProps = Omit<TextInputProps, "isDisabled"> & {
  maskedValue?: string;
};

const TextInputSensitive = ({ maskedValue, value, ...props }: TextInputSensitiveProps) => {
  const [isSensitive, setIsSensitive] = React.useState(true);

  const toggleIsSensitive = React.useCallback(
    (e: React.MouseEvent) => (e.stopPropagation(), setIsSensitive(!isSensitive)),
    [isSensitive, setIsSensitive]
  );

  return (
    <>
      {props.isReadonly ? (
        <TextInput
          {...props}
          copyIfReadonlyValue={value}
          isReadonly
          value={isSensitive ? maskedValue ?? maskValue(value) : value}
          addon={
            <Icon
              className="pointer"
              icon={isSensitive ? IconType.EyeSlash : IconType.Eye}
              onClick={toggleIsSensitive}
            />
          }
        />
      ) : (
        <TextInput
          {...props}
          value={value}
          addon={
            <Icon
              className="pointer"
              icon={isSensitive ? IconType.EyeSlash : IconType.Eye}
              onClick={toggleIsSensitive}
            />
          }
          autoComplete="one-time-code"
          type={isSensitive ? "password" : "text"}
        />
      )}
    </>
  );
};

export default TextInputSensitive;
